import React, { useEffect, useState } from 'react';
import { apiGetProp } from '../../helpers/api';
import Loader from '../Loader/Loader';
import styles from './SelectedProp.module.scss';
import icons from '../../assets';
import cx from 'classnames';
import { setDefaultFiles } from '../../screens/Requests/Sections/helper';
import UploadedFiles from './UploadedFiles';
import Upload3DExistingFile from '../../screens/Requests/Sections/Upload3DExistingFile';
import { REQUESTS_TYPE_LABEL } from '../../constants/constants';

function SelectedProp({ request }) {
  const [prop, setProp] = useState();
  const [show, setShow] = useState(true);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { RequestInfo } = icons;

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleSeeAllClick = () => {
    setShow(!show);
  };

  useEffect(async () => {
    if (request?.product && request?.request_model_type === 'Variation') {
      const response = await apiGetProp(request?.product);
      setProp(response);
    } else if (request?.request_model_type === 'Existing') {
      if (request?.id) setDefaultFiles(request.id, 'productFile', setFiles);
    }
  }, [request]);

  return (
    <>
      <div className={styles.requestInfo}>
        <div className={styles.header}>
          <div className={styles.info}>
            <div className={styles.svg}>
              <RequestInfo />
            </div>{' '}
            Request info
          </div>
          <div className={styles.seeAll} onClick={handleSeeAllClick}>
            {show ? 'close' : 'see all'}
          </div>
        </div>

        <div className={cx(styles.allInfo, show ? styles.show : styles.hidden)}>
          <div>
            <span className={styles.title}>Type : </span>
            <span>
              {request?.request_model_type ? REQUESTS_TYPE_LABEL[request?.request_model_type] : ''}
            </span>
          </div>

          {request?.category_name || prop?.filteroptions?.length ? (
            <div>
              <span className={styles.title}>Category : </span>
              <span>{prop?.filteroptions[0]?.name || request?.category_name}</span>
            </div>
          ) : null}

          {prop ? (
            <div>
              <span className={styles.title}>Prop : </span>
              <span>{prop?.display_name}</span>
            </div>
          ) : null}
        </div>
      </div>

      {prop ? (
        <div className="d-flex align-items-center justify-content-center w-100 h-100">
          {loading && <Loader Loading={loading} size={20} thickness={2} />}
          <img
            className="pt-3"
            src={prop?.thumbnail}
            loading="lazy"
            style={{ width: '100%', objectFit: 'contain', height: '72vh' }}
            onLoad={handleImageLoad}
          />
        </div>
      ) : null}

      {request?.request_model_type === 'Existing' ? (
        <Upload3DExistingFile isReadOnly={true} />
      ) : null}
    </>
  );
}

export default SelectedProp;
